module.exports = __webpack_public_path__ + "img/webinar.ee726663.jpg";